import { renderButton, renderCancelButton, renderTextField } from "@/shared/FormUtils";
import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { fetchAPI } from "@/utility/NetworkUtils";
import { Stack } from "@mui/material";
const CustomFieldModal = ({
  open,
  index,
  formikProps,
  onClose
}) => {
  const isEditing = index != null
  const handleCloseModal = () => {
    formikProps.setFieldValue(`custom_field_modal_name`, "")
    onClose()
  }

  useEffect(() => {
    if(open && index != null) {
      console.log("test")
      formikProps.setFieldValue(`custom_field_modal_name`, formikProps.values.item.custom_fields[index].name)
    }
  }, [open, index])

  const handleSaveField = () => {
    const currentCustomFields = formikProps.values.item.custom_fields||[]
    if(isEditing) {
      formikProps.setFieldValue(`item[custom_fields][${index}].name`, formikProps.values.custom_field_modal_name)
    }else {
      formikProps.setFieldValue(`item[custom_fields]`, [...currentCustomFields, {
        name: formikProps.values.custom_field_modal_name,
        value: ""
      }])
    }
    handleCloseModal()
  }

  return (
    <Modal
      className="react-modal add-form-modal add-custom-field-modal"
      overlayClassName="react-modal-overlay"
      isOpen={open}
      onRequestClose={formikProps.handleCloseModal}
      contentLabel="Add A Custom Field"
    >
      <div class="text-emerald-900 text-xl font-medium font-['Roboto'] pb-4">{isEditing ? "Edit Custom Field" : "Add Custom Field"}</div>
      {renderTextField("Field Name", `custom_field_modal_name`)}
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
      {renderCancelButton("Cancel", handleCloseModal)}
      {renderButton("Save", handleSaveField, {color: "green"})}
      </Stack>
    </Modal>
  )
}


export default CustomFieldModal